import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=4cf90db9&scoped=true&"
import script from "./Sites.vue?vue&type=script&lang=ts&"
export * from "./Sites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf90db9",
  null
  
)

export default component.exports